"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogContent = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogContent = _styledComponents.default.div.withConfig({
  displayName: "DialogContent",
  componentId: "sc-1yvqww2-0"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: theme.global.spacing.xlarge
  };
});

exports.DialogContent = DialogContent;